export function formatProfileRecipientShortName(profile: {
	firstName: string;
	secondName: string;
}): string {
	const firstName = profile.firstName !== '—' ? profile.firstName.trim() : '';
	const secondName = profile.secondName !== '—' ? profile.secondName.trim() : '';
	const lastInitial = secondName.charAt(0);

	if (firstName && lastInitial) {
		return `${firstName} ${lastInitial}.`;
	}

	return [firstName, secondName].filter(Boolean).join(' ');
}
